import { render, staticRenderFns } from "./PageTransition.vue?vue&type=template&id=b58a634c"
import script from "./PageTransition.vue?vue&type=script&lang=js"
export * from "./PageTransition.vue?vue&type=script&lang=js"
import style0 from "./PageTransition.vue?vue&type=style&index=0&id=b58a634c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports